import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DashboardService from "../../api/dashboard";

export const getActiveSubscriptions = createAsyncThunk(
  "activeSubscriptions/get",
  async (id, thunkAPI) => {
    try {
      const response = await DashboardService.getActiveSubscriptions();
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getFailingSubscriptions = createAsyncThunk(
  "failingSubscriptions/get",
  async (id, thunkAPI) => {
    try {
      const response = await DashboardService.getFailingSubscriptions();
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getNewSubscriptions = createAsyncThunk(
  "newSubscriptions/get",
  async (id, thunkAPI) => {
    try {
      const response = await DashboardService.getNewSubscriptions();
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getChurn = createAsyncThunk(
  "churn/get",
  async (id, thunkAPI) => {
    try {
      const response = await DashboardService.getChurn();
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getTotalSales = createAsyncThunk(
  "sales/get",
  async (id, thunkAPI) => {
    try {
      const response = await DashboardService.getTotalSales();
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getTotalSalesByMonth = createAsyncThunk(
  "salesByMonth/get",
  async (id, thunkAPI) => {
    try {
      const response = await DashboardService.getTotalSalesByMonth();
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  results: [],
  count: 0,
  next: null,
  previous: null,
  currentAccount: null,
  events: [],
  error: null,
  loadingUpdate: false,
  totalSalesLoading: false,
  totalSalesByMonthLoading: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: {
    [getActiveSubscriptions.fulfilled]: (state, action) => {
      state.activeSubscriptions = action.payload;
    },
    [getActiveSubscriptions.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja virkar áskriftir";
    },
    [getFailingSubscriptions.fulfilled]: (state, action) => {
      state.failingSubscriptions = action.payload;
    },
    [getFailingSubscriptions.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja áskriftir í hættu";
    },
    [getNewSubscriptions.fulfilled]: (state, action) => {
      state.newSubscriptions = action.payload;
    },
    [getNewSubscriptions.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja nýjar áskriftir";
    },
    [getChurn.fulfilled]: (state, action) => {
      state.churn = action.payload;
    },
    [getChurn.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja uppsagnarhlutfall";
    },
    [getTotalSales.pending]: (state, action) => {
      state.totalSalesLoading = true;
    },
    [getTotalSales.fulfilled]: (state, action) => {
      state.totalSales = action.payload;
      state.totalSalesLoading = false;
    },
    [getTotalSales.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja sölutölur";
      state.totalSalesLoading = false;
    },
    [getTotalSalesByMonth.pending]: (state, action) => {
      state.totalSalesByMonthLoading = true;
    },
    [getTotalSalesByMonth.fulfilled]: (state, action) => {
      state.totalSalesByMonth = action.payload;
      state.totalSalesByMonthLoading = false;
    },
    [getTotalSalesByMonth.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja sölutölur eftir mánuðum";
      state.totalSalesByMonthLoading = false;
    },
  },
});

const { reducer } = dashboardSlice;
export default reducer;